import { render, staticRenderFns } from "./PT210ChukyoMultiOrderParts.vue?vue&type=template&id=70b641b2&"
import script from "./PT210ChukyoMultiOrderParts.vue?vue&type=script&lang=js&"
export * from "./PT210ChukyoMultiOrderParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports